import { conditionalMapOptions } from "../../util/importConditions";

export async function importPopupModule(layerOrigin) {
    try {
        const layer = conditionalMapOptions.layers[layerOrigin];
        const displayPath = `${layer.identifyFeatureDisplay || 'default'}.js`;
  
        let module;
        try {
            module = await import(/* webpackChunkName: "featureDisplays/[request]" */ `../../featureDisplays/${displayPath}`);
        } catch (e) {
            module = await import(/* webpackChunkName: "featureDisplays/default" */ '../../featureDisplays/default.js');
        }
  
        if (module && module.default) {
            return module.default;
        } else {
            throw new Error(`Module at ${displayPath} does not have a default export`);
        }
    } catch (error) {
        console.error("Error importing module:", error);
  
        // Fallback to default module in case of any errors
        const defaultModule = await import('../../featureDisplays/default.js');
        return defaultModule.default;
    }
  }
  